import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { withRouter } from "@/router";
import { mapStateToProps } from "@/store";
import Items from "./Items";
import "./styles/list.scss";
import { getLocalTime, getWatcher } from "@/utils";
import { bootstrapSession, getAuthSnapshot } from "@/utils/auth";
import { queryDaily } from "@/apis";

const TimelineSkeleton = ({ count = 3 }) => (
    <>
        {Array.from({ length: count }, (_, index) => (
            <li className="timeline-skeleton" aria-hidden="true" key={index}>
                <div className="timeline-skeleton__date">
                    <i />
                    <i />
                </div>
                <div className="timeline-skeleton__dot" />
                <div className="timeline-skeleton__card">
                    <i className="timeline-skeleton__title" />
                    <i />
                    <i />
                    <i className="timeline-skeleton__short" />
                    <div className="timeline-skeleton__media" />
                </div>
            </li>
        ))}
    </>
);

class Noresult extends PureComponent {
    render() {
        return (
            <li className="noreault">
                {this.props.text || "暂时没有相关记录"}
            </li>
        );
    }
}

const PostBtn = () => {
    const location = useLocation();
    const navigate = useNavigate();
    async function handleLogin() {
        const REF = location.pathname;
        await bootstrapSession();
        if (getAuthSnapshot().status !== "authenticated") {
            console.warn("没有登录");
            navigate("/login", { state: { query: { ref: REF } } });
            return;
        }
        navigate("/dashboard", { state: { query: { ref: REF } } });
    }
    return (
        <button
            type="button"
            className="btn-post-index"
            aria-label="发布新内容"
            onClick={() => void handleLogin()}
        >
            <svg className="icon" aria-hidden="true">
                <use xlinkHref="#icon-fabu-"></use>
            </svg>
        </button>
    );
};

export class List extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            rows: 10,
            loadmore: false, // 底部加载更多
            scrollCout: true, // 锁住加载更多
            upData: false, // 可以更新数据，锁请求
            noresult: false,
            dailylist: [],
            scrollHeight: null,
            activeBaby: 0,
        };
    }
    static defaultProps = {
        dailylist: [],
        loadmore: false,
        noresult: false,
    };

    componentWillUnmount() {
        const { dispatch } = this.props;
        delete this.state.dailylist;
        // 组件卸载后要取消监听滚动
        window.removeEventListener("scroll", this.getScrolltop);
        dispatch({
            type: "SET_KEEPALIVE",
            data: this.state,
        });
    }
    async componentDidMount() {
        try {
            setTimeout(() => {
                window.addEventListener("scroll", this.getScrolltop);
                this.getScrolltop();
            }, 10);

            const dailyData = await this.getDaily();
            this.setState({
                ...dailyData,
                winHeight: document.documentElement.clientHeight,
            });
        } catch (e) {
            console.error(e);
        }
    }
    getScrolltop = (_event) => {
        const scrolltop =
            document.documentElement.scrollTop || document.body.scrollTop;
        const { setHeadFix } = this.props;

        if (scrolltop > 160) {
            //顶部固定
            setHeadFix(true);
            this.setState(
                {
                    scrollTop: scrolltop,
                },
                this.scrollLoad.bind(this, scrolltop),
            );
        } else {
            setHeadFix(false);
            this.setState(
                {
                    scrollTop: scrolltop,
                },
                this.scrollLoad.bind(this, scrolltop),
            );
        }
    };

    scrollLoad(scrolltop) {
        if (
            !Number.isFinite(this.state.scrollHeight) ||
            this.state.upData ||
            this.state.noresult
        ) {
            return;
        }
        if (
            Number(
                this.state.scrollHeight - this.state.winHeight - scrolltop,
            ) <= 100
        ) {
            console.log("到底了，触发加载更多逻辑");
            !!this.state.scrollCout &&
                this.setState(
                    {
                        loadmore: true,
                        scrollCout: false,
                        upData: true,
                    },
                    async () => {
                        this.setState({
                            ...(await this.getDaily(true)),
                        });
                    },
                );
        }
    }

    async getDaily(append = false, childNo = this.state.activeBaby) {
        /**
         * 从Redux读取keep-alive字段，
         * true的话就恢复原来数据state
         * if (!!this.props.listKeepAlive)
         */
        // !!this.props.listKeepAlive
        const { page, rows } = this.state;
        const { getMainHeight, dispatch } = this.props;

        const daily = await queryDaily({
            page: page,
            rows: rows,
            child: childNo || undefined,
            q: this.state.searchKey || undefined,
        });

        if (!daily.data || daily.code !== 200)
            return console.error(daily.msg || "请求接口异常");

        if (daily.code === -1)
            return {
                noresult: true,
            };

        // 操作creatAt的UTC时间，换成本地时间
        daily["data"].forEach((item) => {
            item._date = getLocalTime(item.createdAt)._date;
            item._year = getLocalTime(item.createdAt)._year;
        });

        // 操作更新数据，concat数组
        let cacheData = [];
        if (append && this.state.dailylist.length > 0) {
            // 把新数组合并到现有数据
            cacheData = [
                ...new Map(
                    [...this.state.dailylist, ...daily["data"]].map((item) => [
                        item.objectId,
                        item,
                    ]),
                ).values(),
            ];
        } else {
            cacheData = daily["data"];
        }

        // console.log('Daily数据', cacheData);
        const loaded = {
            page: this.state.page + 1, // 请求的页数+1
            scrollCout: true, // 继续执行下次
            upData: false, // 更新数据
            loadmore: true, // 隐藏加载更多
        };

        const reachedEnd = daily["data"].length < this.state.rows;

        // 通过prop的方式注入store
        dispatch({
            type: "UPDATE_DAILY",
            dailylist: cacheData,
        });

        return {
            scrollHeight: getMainHeight(),
            noresult: reachedEnd,
            dailylist: cacheData,
            ...loaded,
            loadmore: false,
            scrollCout: !reachedEnd,
        };
    }

    handleChildFilter = (childNo) => {
        if (childNo === this.state.activeBaby) return;
        this.setState(
            {
                activeBaby: childNo,
                page: 1,
                dailylist: [],
                noresult: false,
                loadmore: true,
                scrollCout: false,
                upData: true,
            },
            async () => {
                try {
                    this.setState({ ...(await this.getDaily(false, childNo)) });
                } catch (error) {
                    console.error("按孩子筛选记录失败", error);
                    this.setState({ loadmore: false, upData: false });
                }
            },
        );
    };

    render() {
        const { dailylist, history } = this.props;
        const { loadmore, noresult, activeBaby, upData } = this.state;

        const configuredChildren = Object.values(
            this.props.system?.category || {},
        )
            .map((child) => ({ ...child, no: Number(child.no) }))
            .filter((child) => Number.isInteger(child.no) && child.no > 0)
            .sort((a, b) => a.no - b.no);
        const visibleItems = dailylist;
        const initialLoading = visibleItems.length === 0 && !noresult;

        return (
            <section className="containt">
                <nav className="child-filter" aria-label="按孩子筛选">
                    <button
                        type="button"
                        className={activeBaby === 0 ? "active" : ""}
                        onClick={() => this.handleChildFilter(0)}
                    >
                        全部
                    </button>
                    {configuredChildren.map((child) => (
                        <button
                            key={child.no}
                            type="button"
                            className={activeBaby === child.no ? "active" : ""}
                            onClick={() => this.handleChildFilter(child.no)}
                        >
                            {getWatcher(this.props.system, child.no).name}
                        </button>
                    ))}
                </nav>
                <ul
                    className="dailylist"
                    aria-busy={initialLoading || upData}
                    aria-label={initialLoading ? "正在加载成长记录" : undefined}
                >
                    {initialLoading ? (
                        <TimelineSkeleton />
                    ) : (
                        visibleItems.map((item, index) => (
                            <Items
                                item={item}
                                index={index}
                                key={item.objectId}
                                history={history}
                            />
                        ))
                    )}
                    {loadmore && visibleItems.length > 0 ? (
                        <TimelineSkeleton count={1} />
                    ) : noresult && visibleItems.length === 0 ? (
                        <Noresult text="暂时没有相关记录" />
                    ) : null}
                </ul>
                <PostBtn />
            </section>
        );
    }
}

export default withRouter(connect(mapStateToProps)(List));
